<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content" mat-dialog-content>
  <div class="subtitle1">
    Adobe 官方近期加强全球合规审核，并于 6 月 25
    日凌晨暂停团队计划申请。为减少波动对您工作的影响，平台承担额外成本，提供以下售后方案。
  </div>
  <div class="tabs">
    <div
      class="tab"
      (click)="changeIndex(3)"
      [ngClass]="{ active: index === 3 }"
      *ngIf="info?.remaining_days > 15"
    >
      转为个人摄影计划（PS + LR）
    </div>
    <div
      class="tab"
      (click)="changeIndex(4)"
      [ngClass]="{ active: index === 4 }"
    >
      <img
        src="../../../../assets/images/compensate/check.png"
        *ngIf="index === 4"
        alt=""
      />
      退款到环球巴士钱包
    </div>
  </div>

  <div class="choices" [ngClass]="{ active: index === 3 }">
    <div class="detail1">
      <ul class="plan-points">
        <li>保留剩余 使用时长</li>
        <li>额外赠送 30 天</li>
        <li>非团队版，使用更稳定</li>
      </ul>
    </div>
  </div>
  <div class="choices" [ngClass]="{ active: index === 4 }">
    <div class="detail2">
      您可选择将退款退至环球巴士钱包，余额可在续费或购买新订阅时<span>1:1抵扣</span>使用支持灵活组合支付，操作更加便捷高效。
    </div>
  </div>
</div>

<div class="button" [ngClass]="{ active: index === 3 }">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="change()"
  >
    确认
  </button>
</div>
<div class="button" [ngClass]="{ active: index === 4 }">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="refund()"
  >
    确认退款
  </button>
</div>
